<template>
  <client-tracker :client='client'></client-tracker>
</template>

<script>
import ClientTracker from '@/components/trackers/ClientTracker';

export default {
  name: 'client-action-tracker',
  props: {
    client: {
      required: true
    }
  },
  components: {
    'client-tracker': ClientTracker
  }
}
</script>